import React from 'react';
import { Typography } from '@material-ui/core';
import './FormHeader.css';

export default function FormHeader() {
    return (
            <div className="form-header">
                <img src="https://storage.googleapis.com/static.bit.dev/lp-assets/meerkat_small.png" alt="Meerkat Logo" className="form-logo" />
                <Typography display="inline" variant="h4" component="h1" style={{color: '#756d6a', fontWeight: 600}}>Write for Bits & Pieces</Typography>    
            </div>
            
    )
}
